import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_PO_PDF_LINK_PONUMBER, GET_REFRESH_PURCHASE_ORDER } from '../../Store/FleetManagement/FleetrefreshPurchaseOrder/FleetRefreshPurchaseOrderType'
import { setIsPurchaseOrderRefreshed, setPoPdfLinkByPONumber } from 'Store/FleetManagement/FleetrefreshPurchaseOrder/FleetRefreshPurchaseOrderAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getRefreshPurchaseOrderSaga(req: any): any {
    try {
        yield put(globalLoaderText("Refresh Order...."));

        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/popdf?poNumber=${req?.payload?.poNumber}&savedBy=${req?.payload?.savedBy}`,
            apiMethod: apiMethod.POST,
            payload: req?.saveReceivingBranch
        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setIsPurchaseOrderRefreshed({ isRefreshed: true, response: response, fleetRequestDetailId: req?.payload?.fleetRequestDetailId, poNumber: req?.payload?.poNumber }));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsPurchaseOrderRefreshed({ isRefreshed: false, response: null, fleetRequestDetailId: req?.payload?.fleetRequestDetailId, poNumber: req?.payload?.poNumber }));
        yield put(globalLoaderText(""));
    }
}

function* getPoPdfByPONumberSaga(req: any): any {
    try {
        yield put(globalLoaderText("Refresh Order...."));

        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/popdf/${req?.payload?.poNumber}`,
            apiMethod: apiMethod.GET,
            payload: req?.saveReceivingBranch
        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setPoPdfLinkByPONumber({response: response, fleetRequestDetailId: req?.payload?.fleetRequestDetailId, poNumber: req?.payload?.poNumber}));
        }else{
            yield put(setPoPdfLinkByPONumber({response: null, fleetRequestDetailId: req?.payload?.fleetRequestDetailId, poNumber: req?.payload?.poNumber}));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setPoPdfLinkByPONumber({response: null, fleetRequestDetailId: req?.payload?.fleetRequestDetailId, poNumber: req?.payload?.poNumber}));
        yield put(globalLoaderText(""));
    }
}

function* watchGetRefreshPurchaseOrder() {
    yield takeEvery(GET_REFRESH_PURCHASE_ORDER, getRefreshPurchaseOrderSaga)
    yield takeEvery(GET_PO_PDF_LINK_PONUMBER, getPoPdfByPONumberSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetRefreshPurchaseOrder()
    ])
}
